import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './report-container.scss';
import AdHocReports from './components/adhoc-reports/adhoc-reports';
import CorporateActionsReports from './components/corporate-actions-reports/corporate-actions-reports';
import WorkflowReports from './components/workflow-reports/workflow-reports';

const Content = ({ selectedItem }) => {
  const [key, setKey] = useState('tab1');

  if (!selectedItem) {
    return <Container className="report-container"><div>Select an item to see details</div></Container>;
  }

  const reports = selectedItem.reports || {};
  const isin = selectedItem.isin;
  const securityName = selectedItem.name
  const issuerName = selectedItem.issuerName

  return (
    <Container className="report-container">
      <Row>
        <Col>
          <div className="item-container">
            <div className="item-name">{selectedItem.name}</div>
            <Row>
              <Col md={6}>
                <div className="item-detail">ISIN Number: {selectedItem.isin}</div>
                <div className="item-detail">Issuance Date: {selectedItem.issuanceDate}</div>
              </Col>
              <Col md={6}>
                <div className="item-detail">Maturity Date: {selectedItem.maturityDate}</div>
                <div className="item-detail">Listing Date: {selectedItem.listingDate}</div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <div className="tab-container">
            <div
              className={`tab-link ${key === 'tab1' ? 'active' : ''}`}
              onClick={() => setKey('tab1')}
            >
              Corporate Actions Payment Reports
            </div>
            <div
              className={`tab-link ${key === 'tab2' ? 'active' : ''}`}
              onClick={() => setKey('tab2')}
            >
              Ad-hoc Reports
            </div>
            <div
              className={`tab-link ${key === 'tab3' ? 'active' : ''}`}
              onClick={() => setKey('tab3')}
            >
              Tax-Exempt Reports
            </div>
          </div>
          <div className="tab-content mt-3">
            {key === 'tab1' && <CorporateActionsReports reports={reports.corporateReports || []} itemIsin={isin}/>}
            {key === 'tab2' && <AdHocReports reports={reports.adhocReports || []}  securityName={securityName || []} isin={isin} issuerName={issuerName || []}/>}
            {key === 'tab3' && <WorkflowReports reports={reports.workflowReports || []}/>}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Content;
